import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { FormControlLabel, Switch, SwitchProps } from '@mui/material'
import { useStyles } from 'src/Components/toggle/Toggle'

type Props = {
  name: string
  label?: string
  propsOnChange?: (checked: boolean) => void
} & Omit<SwitchProps, 'name' | 'type'>

/**
 * MUI Toggle with react hook form
 */
const Toggle: React.FC<Props> = ({ name, label, disabled, propsOnChange, ...props }) => {
  const { control } = useFormContext()
  const { classes } = useStyles({ disabled: Boolean(disabled) })

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          sx={{
            margin: 0,
          }}
          control={
            <Switch
              className={classes.switchStyle}
              checked={field.value}
              {...field}
              onChange={(e, checked) => {
                field.onChange(e)
                propsOnChange?.(checked)
              }}
              disabled={disabled}
              {...props}
            />
          }
          label={label}
        />
      )}
    />
  )
}

Toggle.displayName = 'Toggle'

export default Toggle
